import React from 'react'
import { useScreenResize } from './useScreenResize'

export function useRenderedElementWidth(id: string): number {
  const [elementWidth, setElementWidth] = React.useState<number>(0)

  const setWidthOnResize = React.useCallback(() => {
    const element = document.getElementById(id)
    setElementWidth(element?.clientWidth || 0)
  }, [id])

  useScreenResize(setWidthOnResize)

  React.useEffect(() => {
    if (!elementWidth) {
      setWidthOnResize()
    }
  }, [setWidthOnResize, elementWidth])

  return elementWidth
}
